import DefaultMerchandise from '@assets/default-merchandise.svg';
// import { useEffect, useState } from 'react';
import classes from './index.module.css';

/** 商品组件 */
export const Merchandise = ({
  item, className = '', children, isShowQuantity,
}) => {
  const {
    actualPrice,
    price,
    hasDiscount,
    image,
    imageUrl = DefaultMerchandise,
    itemTitle: title,
    sku,
    variantTitle,
    claimQuantity, quantity,
  } = item || {};

  // const [titleWidth, setTitleWidth] = useState(0);

  // useEffect(() => {
  //   const lineItem = document.querySelector('#responsive_line_item');
  //   const checkbox = document.querySelector('#responsive_line_item_checkbox');
  //   if (lineItem && checkbox) {
  //     const { width } = lineItem.getBoundingClientRect();
  //     const { width: checkboxWidth } = checkbox.getBoundingClientRect();
  //     const tw = width - checkboxWidth - 60 - 80 - 40;
  //     if (tw > 0) {
  //       setTitleWidth(tw);
  //     }
  //   }
  // }, []);

  return (
    <section className={`${classes.merchandise} ${className}`}>
      <section className={classes.content}>
        <section className={classes.item_info}>
          <img
            src={image || imageUrl || DefaultMerchandise}
            className={classes.item_img}
            alt=""
            onError={(e) => {
              const img = e.currentTarget;
              img.src = DefaultMerchandise;
              img.οnerrοr = null;
            }}
          />
          <section className={classes.info_block}>
            {title ? <section className={classes.title}>{title}</section> : null}
            {variantTitle ? <section className={classes.sub_title}>{variantTitle}</section> : null}
            {sku ? <section className={classes.sub_title}>{`SKU: ${sku}`}</section> : null}
          </section>
        </section>
        <section className={classes.price_block}>
          {actualPrice ? <section className={classes.price}>{`${actualPrice}`}</section> : null}
          {hasDiscount ? <section className={classes.actual_price}>{`${price}`}</section> : null}
        </section>
        {isShowQuantity && (claimQuantity || quantity) && <section className={classes.price_block}>{`x${claimQuantity || quantity}`}</section>}
      </section>
      {children}
    </section>
  );
};
